$.extend(true, BT, {
  initProductTabs: function(wrap, sectionId) {
    if(wrap.hasClass('has-available-data')) {
    var firstSliderWrap;
    if(typeof wrap == 'string') {
      firstSliderWrap = wrap + ' .tab-pane:first';
      wrap = $(wrap);
    } else {
      firstSliderWrap = wrap.find('.tab-pane:first');
    }
    this.convertCurrencySilence(wrap.find('span.money'));
      this.initScrollingWindowTriggerOnce(wrap, 'product-tabs_deal_slider_' + sectionId, -170, () => {
        this.initDealCountdown(wrap);
        this.initSlider(firstSliderWrap, false, false);
    });
    }
    this.initInfiniteScroll(wrap);
    if(wrap.find(this.selectors.waitingTabData).length > 0) {
      this.initScrollingWindowTriggerOnce(wrap, 'product-tabs_ajax_' + sectionId, -450, () => {
        this.renderSectionByAjaxApi(sectionId, {}, (response) => {
          wrap.find(this.selectors.waitingTabData).each((index, waitingEle) => {
            var parent = $(waitingEle).parent();
            $(waitingEle).remove();
            parent.html('');
            var html = $('#' + parent.attr('id'), response).parent()[0].outerHTML;
            this.afterLoadDynamicProductsAjaxInTab(parent, html);
            this.initSlider(parent.parent(), false, false);
          });
          this.addProductMetaData(wrap, true);
        });
      });
    }
    wrap.find('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      const href = $(e.target).attr('href');
      var tabContent = $(href);
      if (tabContent.find(this.selectors.infiniteScroll.wait).length > 0) {
        tabContent.find(this.selectors.infiniteScroll.wait).removeClass(this.selectors.infiniteScroll.wait.replace('.','')).addClass(this.selectors.infiniteScroll.button.replace('.',''));
        this.initInfiniteScroll(tabContent);
      }
      if(Shopify.designMode) {
        if(tabContent.hasClass('opened')) {
          this.destroyDealCountdown(tabContent);
          this.destroySlider(tabContent);
        }
        this.initDealCountdown(tabContent);
        this.initSlider(tabContent, false, false);
        tabContent.addClass('opened');
      }
    });
  },

  unLoadProductTabs: function(wrap) {
    const sectionId = wrap.attr('data-section-id');
    this.destroyInfiniteScroll(wrap.attr('data-section-id'));
    this.destroyScrollingWindowTriggerOnce('product-tabs_ajax_' + sectionId);
    this.destroyScrollingWindowTriggerOnce('product-tabs_deal_slider_' + sectionId);
    this.destroyDealCountdown(wrap);
  }
});

class ProductTabsSection extends BTSection {
  onInit() {
    BT.initProductTabs(this.container, this.sectionId);
  }


  onBlockSelect(evt) {
    var tab = $(evt.target);
    if(!tab.hasClass('active')) {
      var tabNav = $('a[href="#' + tab.attr('id') + '"]');
      tabNav.trigger('click');
    }
    if(!BT.isInViewport(this.container, evt.currentTarget.defaultView)) {
      var offset = this.container.offset().top - 100;
      $('html, body').animate({
        scrollTop: offset
      }, 400);
    }
  }

  onUnload(evt) {
    BT.unLoadProductTabs(this.container);
    // delete this.wrap;
  }
}

theme.sections.constructors['product-tabs'] = ProductTabsSection;